import { Reveal } from "./shared";

const STATS = [
  ["60 min", "Per session, on-site"],
  ["12 max", "People per group"],
  ["144", "Trained in a single day"],
  ["100%", "Doctor-led teaching"],
];

export const StatsStrip = () => (
  <section className="border-y border-[#E7E3D9] bg-white px-4 py-12 sm:px-6 lg:px-8" data-testid="stats-strip">
    <div className="mx-auto max-w-7xl">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
        {STATS.map(([stat, label], i) => (
          <Reveal key={label} delay={i * 0.06} className="text-center">
            <p className="font-display text-3xl font-bold text-[#1E7B4F] sm:text-4xl">{stat}</p>
            <p className="mt-1 text-sm font-medium text-[#5F6E63]">{label}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
